export var UserSchoolMembershipStatus;
(function (UserSchoolMembershipStatus) {
    UserSchoolMembershipStatus["Active"] = "active";
    UserSchoolMembershipStatus["Inactive"] = "inactive";
    UserSchoolMembershipStatus["Pending"] = "pending";
    UserSchoolMembershipStatus["Rejected"] = "rejected";
    UserSchoolMembershipStatus["InvitationSent"] = "invitationSent";
})(UserSchoolMembershipStatus || (UserSchoolMembershipStatus = {}));
